import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.includes";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { areaList, agentList, agentHandle, agentDelete } from '@/api/apis';
import tableExcelSelect from '@/components/rw/tempTable/components/tableExcelSelect';
export default {
  name: 'regionAgent',
  components: {
    tableExcelSelect: tableExcelSelect
  },
  data: function data() {
    return {
      loading: false,
      searchKeyword: '',
      appliedKeyword: '',
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      areaOptions: [],
      areaMap: {},
      cascaderProps: {
        value: 'id',
        label: 'name',
        children: 'children',
        checkStrictly: false
      },
      // 添加弹窗
      addDialogVisible: false,
      addLoading: false,
      addForm: {
        number: '',
        region: []
      },
      addRules: {
        number: [{
          required: true,
          message: '请输入会员编号',
          trigger: 'blur'
        }],
        region: [{
          required: true,
          message: '请选择区域',
          trigger: 'change'
        }]
      },
      // 导出字段
      exportModel: [{
        show: 1,
        label: '会员编号',
        prop: 'number'
      }, {
        show: 1,
        label: '姓名',
        prop: 'real_name'
      }, {
        show: 1,
        label: '电话',
        prop: 'phone'
      }, {
        show: 1,
        label: '省',
        prop: 'province_name'
      }, {
        show: 1,
        label: '市',
        prop: 'city_name'
      }, {
        show: 1,
        label: '区/县',
        prop: 'district_name'
      }, {
        show: 1,
        label: '添加时间',
        prop: 'add_time'
      }]
    };
  },
  computed: {
    filteredData: function filteredData() {
      var _this = this;

      var result = this.tableData; // 按会员编号过滤

      if (this.appliedKeyword) {
        result = result.filter(function (item) {
          return item.number && item.number.includes(_this.appliedKeyword);
        });
      }

      return result;
    },
    pagedData: function pagedData() {
      return this.filteredData;
    }
  },
  mounted: function mounted() {
    this.loadAreaOptions();
    this.loadData();
  },
  methods: {
    // 加载省市区数据
    loadAreaOptions: function loadAreaOptions() {
      var _this2 = this;

      areaList({}).then(function (res) {
        _this2.areaOptions = res || [];

        _this2.buildAreaMap();
      });
    },
    // 构建 id -> name 的映射
    buildAreaMap: function buildAreaMap() {
      var map = {};

      var walk = function walk(nodes) {
        if (!nodes) return;

        for (var i in nodes) {
          map[nodes[i].id] = nodes[i].name;
          if (nodes[i].children) walk(nodes[i].children);
        }
      };

      walk(this.areaOptions);
      this.areaMap = map;
    },
    // 根据 id 获取区域名称
    getAreaName: function getAreaName(id) {
      if (!id) return '';
      return this.areaMap[id] || id;
    },
    // 加载代理区域列表
    loadData: function loadData() {
      var _this3 = this;

      this.loading = true;
      var params = {
        page: this.currentPage,
        limit: this.pageSize
      };

      if (this.appliedKeyword) {
        params.where = {
          number: this.appliedKeyword
        };
      }

      agentList(params).then(function (res) {
        var data = res && res.data ? res.data : res;
        _this3.tableData = data && data.rows || [];
        _this3.total = data && data.count || 0;
        _this3.loading = false;
      }).catch(function () {
        _this3.tableData = [];
        _this3.total = 0;
        _this3.loading = false;
      });
    },
    // 搜索
    onSearch: function onSearch() {
      this.appliedKeyword = this.searchKeyword;
      this.currentPage = 1;
      this.loadData();
    },
    // 刷新：清空搜索条件重新加载
    onRefresh: function onRefresh() {
      this.searchKeyword = '';
      this.appliedKeyword = '';
      this.loadData();
    },
    onSizeChange: function onSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.loadData();
    },
    onPageChange: function onPageChange(page) {
      this.currentPage = page;
      this.loadData();
    },
    // 导出Excel
    onExport: function onExport() {
      var _this4 = this;

      var title = '代理区域列表';
      this.$refs['excel'].show(title, this.exportModel, function (ret, tag, model) {
        if (!ret) return;
        var columns = model.filter(function (item) {
          return item.show === 1;
        });

        if (columns.length === 0) {
          _this4.$message({
            message: '请至少勾选一个导出字段',
            type: 'warning'
          });

          return;
        }

        _this4.$g.fun.startLoading();

        _this4.getExportData(tag).then(function (data) {
          _this4.$export.excel({
            columns: columns,
            data: data,
            title: title
          }).then(function () {
            _this4.$g.fun.endLoading();
          });
        }).catch(function () {
          _this4.$g.fun.endLoading();
        });
      });
    },
    getExportData: function getExportData(isAll) {
      var _this5 = this;

      var finish = function finish(rows) {
        return rows.map(function (r) {
          return {
            number: r.number,
            real_name: r.t_user ? r.t_user.real_name : '',
            phone: r.t_user ? r.t_user.phone : '',
            province_name: _this5.getAreaName(r.province),
            city_name: _this5.getAreaName(r.city),
            district_name: _this5.getAreaName(r.district),
            add_time: r.add_time
          };
        });
      };

      if (isAll === 0) {
        return Promise.resolve(finish(this.filteredData));
      }

      var params = {
        page: 1,
        limit: 1000000
      };

      if (this.appliedKeyword) {
        params.where = {
          number: this.appliedKeyword
        };
      }

      return agentList(params).then(function (res) {
        var data = res && res.data ? res.data : res;
        var rows = data && data.rows || [];

        if (_this5.appliedKeyword) {
          rows = rows.filter(function (item) {
            return item.number && item.number.includes(_this5.appliedKeyword);
          });
        }

        return finish(rows);
      });
    },
    // 显示添加弹窗
    showAddDialog: function showAddDialog() {
      var _this6 = this;

      this.addForm = {
        number: '',
        region: []
      };
      this.addDialogVisible = true;
      this.$nextTick(function () {
        if (_this6.$refs.addForm) {
          _this6.$refs.addForm.clearValidate();
        }
      });
    },
    // 提交添加
    onAddSubmit: function onAddSubmit() {
      var _this7 = this;

      this.$refs.addForm.validate(function (valid) {
        if (!valid) return;

        if (_this7.addForm.region.length < 3) {
          _this7.$message({
            message: '请选择到区/县级',
            type: 'warning'
          });

          return;
        }

        _this7.addLoading = true;
        var region = _this7.addForm.region;

        var province = _this7.areaOptions.find(function (p) {
          return p.id === region[0];
        });

        var city = province ? province.children.find(function (c) {
          return c.id === region[1];
        }) : null;
        var district = city ? city.children.find(function (d) {
          return d.id === region[2];
        }) : null;
        var data = {
          number: _this7.addForm.number,
          province: province ? province.id : '',
          city: city ? city.id : '',
          district: district ? district.id : ''
        };
        agentHandle(data).then(function (res) {
          _this7.$message({
            message: '添加成功',
            type: 'success'
          });

          _this7.addDialogVisible = false;
          _this7.addLoading = false;

          _this7.loadData();
        }).catch(function () {
          _this7.addLoading = false;
        });
      });
    },
    // 移除代理区域
    onRemove: function onRemove(row) {
      var _this8 = this;

      this.$confirm("\u786E\u8BA4\u79FB\u9664\u300C".concat(row.number, "\u300D\u7684\u4EE3\u7406\u8D44\u683C\uFF1F"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        agentDelete({
          number: row.number
        }).then(function (res) {
          _this8.$message({
            message: '移除成功',
            type: 'success'
          });

          _this8.loadData();
        });
      }).catch(function () {});
    }
  }
};